module.exports = __webpack_public_path__ + "static/img/logo1.9bd6a42.png";


//////////////////
// WEBPACK FOOTER
// ./static/index/logo1.png
// module id = VOkJ
// module chunks = 74